import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import { formatDate } from "../lib/format";
import { StatusBadge } from "./ArticleList";

const CARDS = [["Total Articles", "total"], ["Published", "published"], ["Drafts", "drafts"], ["Scheduled", "scheduled"], ["Categories", "categories"], ["Tips", "tips"], ["Articles This Week", "this_week"], ["Subscribers", "subscribers"]];

export default function Dashboard() {
  useSeo({ title: "Admin Dashboard", robots: "noindex,nofollow" });
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="eyebrow">Overview</p><h1 className="mt-1 font-serif text-3xl font-semibold">Dashboard</h1></div>
        <Link to="/admin/articles/new" className="btn-primary" data-testid="admin-new-article-button"><Plus size={16} /> New article</Link>
      </div>
      <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {CARDS.map(([label, key]) => (
          <div key={key} className="card-ab p-5" data-testid={`stat-${key}`}>
            <p className="text-xs font-semibold uppercase tracking-wider text-ab-muted">{label}</p>
            <p className="mt-2 font-serif text-3xl font-semibold">{stats ? stats[key] : "—"}</p>
          </div>
        ))}
      </div>
      <section className="card-ab mt-8 overflow-hidden">
        <div className="flex items-center justify-between border-b border-ab-border px-5 py-4"><h2 className="font-semibold">Recently updated</h2><Link to="/admin/articles" className="btn-ghost text-xs">All articles</Link></div>
        <ul className="divide-y divide-ab-border">
          {stats?.recent.map((a) => (
            <li key={a.id} className="flex items-center justify-between gap-4 px-5 py-3 text-sm">
              <Link to={`/admin/articles/${a.id}`} className="min-w-0 truncate font-medium hover:text-ab-accent" data-testid={`recent-article-${a.id}`}>{a.title}</Link>
              <div className="flex shrink-0 items-center gap-3 text-xs text-ab-muted"><StatusBadge status={a.status} /><span>{formatDate(a.updated_at)}</span></div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
